import { render, staticRenderFns } from "./InternalsCreate.vue?vue&type=template&id=e7db299e"
import script from "./InternalsCreate.vue?vue&type=script&lang=js"
export * from "./InternalsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports